import React from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileDownload } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Link, ListItem, Text,
} from '@domain-group/suit-theme'

const UploadedPDF = (props) => {
  const { provider } = props

  const { invoice_pdf } = provider

  const {
    file_name,
    file_updated_at,
    original: fileUrl,
  } = invoice_pdf || {}

  return (
    <ListItem
      boxProps={{
        alignItems: 'center',
        borderBottom: '1px dashed',
        fontSize: 'small',
        lineHeight: 1.3,
        justifyContent: 'space-between',
      }}
      disableHover
    >
      <Box flexDirection="column" maxWidth="80%">
        <Text fontSize="xsmall" variant="ellipsis">
          {file_name}
        </Text>

        {file_updated_at && (
          <Text color="faintGrey" fontSize="xsmall">
            Uploaded {file_updated_at}
          </Text>
        )}
      </Box>

      <Box width="fit-content">
        {fileUrl && (
          <Link
            greyLink
            href={fileUrl}
            target="_blank"
            textProps={{ marginRight: 'medium' }}
          >
            <FontAwesomeIcon icon={faFileDownload} />
          </Link>
        )}
      </Box>
    </ListItem>
  )
}

UploadedPDF.propTypes = {
  provider: PropTypes.object.isRequired,
}

export default UploadedPDF
